import { useState } from 'react'
import { motion } from 'framer-motion'
import { FaPhone, FaEnvelope, FaMapMarkerAlt } from 'react-icons/fa'
import PageHeader from '@/components/PageHeader'
import AdminPageContainer from '@/components/AdminPageContainer'

interface ContactInfo {
  phone: string
  email: string
  address: string
  whatsapp: string
  googleMapsUrl: string
}

const initialContacts: ContactInfo = {
  phone: '(15) 99822-5714',
  email: 'comercial@uniaoferr.com',
  address: 'Araçoiaba da Serra/SP',
  whatsapp: '5515998225714',
  googleMapsUrl:
    'https://www.google.com/maps?q=Tv.+Terceira+do+Jaiminho,+271,+Jd.+Arco+Rio+Verde,+Araçoiaba+da+Serra',
}

export default function AdminContacts() {
  const [contacts, setContacts] = useState<ContactInfo>(initialContacts)
  const [isSaving, setIsSaving] = useState(false)
  const [saveMessage, setSaveMessage] = useState('')

  const handleSave = async () => {
    setIsSaving(true)
    setSaveMessage('')

    try {
      // Simulating an API call
      await new Promise((resolve) => setTimeout(resolve, 1000))
      setSaveMessage('Informações de contato atualizadas com sucesso!')
      setTimeout(() => setSaveMessage(''), 3000)
    } catch (error) {
      setSaveMessage('Erro ao salvar informações de contato.')
    } finally {
      setIsSaving(false)
    }
  }

  return (
    <AdminPageContainer>
      <div className="space-y-6">
        <PageHeader title="Gerenciar Contatos" onSave={handleSave} isSaving={isSaving} />

        {saveMessage && (
          <motion.div
            initial={{ opacity: 0, y: -10 }}
            animate={{ opacity: 1, y: 0 }}
            className={`rounded-md p-4 ${
              saveMessage.includes('sucesso')
                ? 'bg-green-50 text-green-800'
                : 'bg-red-50 text-red-800'
            }`}
          >
            {saveMessage}
          </motion.div>
        )}

        <div className="grid gap-6 lg:grid-cols-2">
          <motion.div
            initial={{ opacity: 0, y: 20 }}
            animate={{ opacity: 1, y: 0 }}
            className="rounded-lg bg-white p-6 shadow"
          >
            <h3 className="mb-4 text-lg font-medium text-gray-900">
              Informações de Contato
            </h3>
            <div className="space-y-4">
              <div>
                <label
                  htmlFor="phone"
                  className="block text-sm font-medium text-gray-700"
                >
                  <FaPhone className="mr-2 inline h-4 w-4" />
                  Telefone
                </label>
                <input
                  type="text"
                  id="phone"
                  value={contacts.phone}
                  onChange={(e) =>
                    setContacts((prev) => ({ ...prev, phone: e.target.value }))
                  }
                  className="mt-1 block w-full rounded-md border-gray-300 shadow-sm focus:border-primary-500 focus:ring-primary-500 sm:text-sm"
                />
              </div>

              <div>
                <label
                  htmlFor="whatsapp"
                  className="block text-sm font-medium text-gray-700"
                >
                  <FaPhone className="mr-2 inline h-4 w-4" />
                  WhatsApp
                </label>
                <input
                  type="text"
                  id="whatsapp"
                  value={contacts.whatsapp}
                  onChange={(e) =>
                    setContacts((prev) => ({ ...prev, whatsapp: e.target.value }))
                  }
                  className="mt-1 block w-full rounded-md border-gray-300 shadow-sm focus:border-primary-500 focus:ring-primary-500 sm:text-sm"
                />
              </div>

              <div>
                <label
                  htmlFor="email"
                  className="block text-sm font-medium text-gray-700"
                >
                  <FaEnvelope className="mr-2 inline h-4 w-4" />
                  E-mail
                </label>
                <input
                  type="email"
                  id="email"
                  value={contacts.email}
                  onChange={(e) =>
                    setContacts((prev) => ({ ...prev, email: e.target.value }))
                  }
                  className="mt-1 block w-full rounded-md border-gray-300 shadow-sm focus:border-primary-500 focus:ring-primary-500 sm:text-sm"
                />
              </div>
            </div>
          </motion.div>

          <motion.div
            initial={{ opacity: 0, y: 20 }}
            animate={{ opacity: 1, y: 0 }}
            className="rounded-lg bg-white p-6 shadow"
          >
            <h3 className="mb-4 text-lg font-medium text-gray-900">
              Localização
            </h3>
            <div className="space-y-4">
              <div>
                <label
                  htmlFor="address"
                  className="block text-sm font-medium text-gray-700"
                >
                  <FaMapMarkerAlt className="mr-2 inline h-4 w-4" />
                  Endereço
                </label>
                <textarea
                  id="address"
                  rows={3}
                  value={contacts.address}
                  onChange={(e) =>
                    setContacts((prev) => ({ ...prev, address: e.target.value }))
                  }
                  className="mt-1 block w-full rounded-md border-gray-300 shadow-sm focus:border-primary-500 focus:ring-primary-500 sm:text-sm"
                />
              </div>

              <div>
                <label
                  htmlFor="googleMapsUrl"
                  className="block text-sm font-medium text-gray-700"
                >
                  <FaMapMarkerAlt className="mr-2 inline h-4 w-4" />
                  URL do Google Maps
                </label>
                <input
                  type="url"
                  id="googleMapsUrl"
                  value={contacts.googleMapsUrl}
                  onChange={(e) =>
                    setContacts((prev) => ({
                      ...prev,
                      googleMapsUrl: e.target.value,
                    }))
                  }
                  className="mt-1 block w-full rounded-md border-gray-300 shadow-sm focus:border-primary-500 focus:ring-primary-500 sm:text-sm"
                  placeholder="https://www.google.com/maps?q=..."
                />
              </div>
            </div>
          </motion.div>
        </div>
      </div>
    </AdminPageContainer>
  )
}
